<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 9.6875H3H4V7.8125H3H2V9.6875ZM3 7H2V6V5.9375V5H3H4V5.9375H3L3 6V7ZM5 5H7V6V7H5V6V5ZM2 19V18H3V19V19.0625H4V20H3H2V19.0625V19ZM22 6V7H21V6V5.9375H20V5H21H22V5.9375V6ZM9 6V5H11V6V7H9V6ZM13 6V5H15V6V7H13V6ZM17 6V5H19V6V7H17V6ZM21 7.8125H22V9.6875H21H20V7.8125H21ZM21.4071 11.5625H22V12.1025C21.8129 11.9115 21.6149 11.7312 21.4071 11.5625ZM10.071 18C10.1721 18.7061 10.3788 19.3782 10.6744 20H9V19V18H10.071ZM7 19V20H5V19V18H7V19ZM3 17.1875H2V15.3125H3H4V17.1875H3ZM3 13.4375H2V11.5625H3H4V13.4375H3Z"
      fill="#052E37"
    />
    <path
      d="M17 12C14.24 12 12 14.24 12 17C12 19.76 14.24 22 17 22C19.76 22 22 19.76 22 17C22 14.24 19.76 12 17 12ZM19.5 17.5H17.5V19.5H16.5V17.5H14.5V16.5H16.5V14.5H17.5V16.5H19.5V17.5Z"
      fill="#052E37"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ZamgRectangleAdd',
});
</script>
<style scoped></style>
